import React, { useState } from "react";
import "./MessageA23A.css";

const MessageA23A = (item) => {
  const data = item.item;
  const [selectedPlan, setSelectedPlan] = useState();
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="volte-text">
      <p className="chat-text">{data.bingePlanText}</p>

      <div className="msgA23A-iconGrid">
        {(showAll ? data.appData : data.appData.slice(0, 8)).map((app, index) => (
          <img key={index} src={app.appLink} alt={app.appName} className="msgA23A-icon" />
        ))}

        <div className="msgA23A-seeAll" onClick={() => setShowAll(!showAll)}>
          <div >
            <div style={{ textAlign: "center", width: "46px" }}>
              <svg className="msgA23A-seeAllIcon" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <rect y="0.2" width="16" height="16" rx="8" fill="#E10092" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d={
                    showAll
                      ? "M8 5.83333L12.5825 9.54882C12.9694 9.86248 12.9694 10.4527 12.5825 10.7664C12.2948 10.9997 11.883 10.9997 11.5953 10.7664L8 7.85129L4.40471 10.7664C4.11699 10.9997 3.70521 10.9997 3.4175 10.7664C3.03063 10.4527 3.03063 9.86248 3.4175 9.54882L8 5.83333Z"
                      : "M8 11.3667L3.4175 7.65119C3.03063 7.33752 3.03063 6.74729 3.4175 6.43362C3.70521 6.20033 4.11699 6.20033 4.40471 6.43362L8 9.34871L11.5953 6.43362C11.883 6.20033 12.2948 6.20033 12.5825 6.43362C12.9694 6.74729 12.9694 7.33752 12.5825 7.65119L8 11.3667Z"
                  }
                  fill="white"
                />
              </svg>
            </div>
            <div style={{ fontSize: "12px", fontWeight: "600", whiteSpace: "nowrap" }}>{showAll ? 'Show Less' : 'See All'}</div>
          </div>
        </div>
      </div>

      {data?.buttonText && data?.buttonText?.map((plan) => {
        const isSelected = selectedPlan === plan.label;
        return (
          <div
            key={plan.id}
            className="msgA23A-planRow"
            onClick={() => setSelectedPlan(plan.label)}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className={`msgA23A-customRadio ${isSelected ? "msgA23A-customRadioSelected" : ""}`}>
                {isSelected && <div className="msgA23A-innerDot"></div>}
              </div>
              <span className={isSelected ? "msgA23A-planLabelSelected" : "msgA23A-planLabel"}>
                {plan.label}
              </span>
            </div>
            <span className="msgA23A-price" style={{ color: isSelected ? "#d63384" : "#000" }}>
              ₹{plan.price}/month
            </span>
          </div>
        );
      })}
      <div style={{
        // marginTop: "20px",
        marginBottom: "10px",
        borderBottom: "2px solid #ccc",
      }} />
      {data.belowText && <p className="chat-text">{data.belowText}</p>
      }
      {data.ctaButton && <button className="msgA23A-viewbutton">{data.ctaButton}</button>
      }    
      </div>
  );
};

export default MessageA23A;
